import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner"></div>
        <p>航行情報を読み込み中...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
